const MAP_OPTIONS = {
  extent: {
    xmin: -470240,
    ymin: -322320,
    xmax: 929410,
    ymax: 1265180,
    spatialReference: { wkid: 27700 },
  },
  zoom: 7,
};
// const ARCGIS_ENV_URL = `${
//   process.env.NODE_ENV === "development"
//     ? `//arcgis.rcdo.co.uk/devserver/`
//     : `//ukairmaps.staging.rcdo.co.uk/ukairserver/`
// }`;
const map = {
    ["localhost"]: "//ukair.maps.staging.rcdo.co.uk/ukairserver/",
    ["uk-air.staging.ricardo-aea.com"]: "//ukair.maps.staging.rcdo.co.uk/ukairserver/",
    ["uk-air.dev.rcdo.co.uk"]: "//ukair.maps.staging.rcdo.co.uk/ukairserver/",
    ["uk-air.staging.rcdo.co.uk"]: "//ukair.maps.staging.rcdo.co.uk/ukairserver/",
    ["uk-air.defra.gov.uk"]: "//ukair.maps.rcdo.co.uk/ukairserver/",
};

const currentHostname = window?.location?.hostname || "INVALID";

const ARCGIS_ENV_URL = map[currentHostname];

if (!ARCGIS_ENV_URL) {
  console.log(map);
  throw new Error(`UNABLE TO MATCH CONFIG FOR HOSTMANE: "${currentHostname}"`);
}

const ARCGIS_SERVICES_ROOT_URL = ARCGIS_ENV_URL + "rest/services/";
const APP_SETTINGS = {
  _VERSION: "1.0",
  GIS_SERVER: {
    LA_URL:
      ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authorities/FeatureServer/0",
    LA_2020_URL:
      ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authority_Boundaries_Comp_2020/FeatureServer/0",
    LA_2021_URL:
      ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authority_Boundaries_Comp_2021/FeatureServer/0",
    LA_2022_URL:
        ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authority_Boundaries_Comp_2022/FeatureServer/0",
    LA_2023_URL:
        ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authority_Boundaries_Comp_2023/FeatureServer/0",
    LA_2024_URL:
        ARCGIS_SERVICES_ROOT_URL + "Hosted/Local_Authority_Boundaries_Comp_2024/FeatureServer/0",
    ZONE_URL:
      ARCGIS_SERVICES_ROOT_URL + "Hosted/Zones_Agglomerations/FeatureServer/0",
    GP: {
      LIST_OF_SERVICE_URL:
        ARCGIS_SERVICES_ROOT_URL + "geotools/comp_service_list_v1/GPServer/get_list",
      SERVICE_INFO_URL:
        ARCGIS_SERVICES_ROOT_URL +
        "geotools/comp_layers_info_v1/GPServer/get_layers_info",
      DOWNLOAD_LAYER_URL:
        ARCGIS_SERVICES_ROOT_URL +
        "System/SpatialAnalysisTools/GPServer/ExtractData",
      DOWNLOAD_CSV_LAYER_URL:
        ARCGIS_SERVICES_ROOT_URL + "geotools/comp_encode_csv_v1/GPServer/get_csv",
    },
    NI: {
      OS_GREY: ARCGIS_SERVICES_ROOT_URL + "Hosted/osgrey/FeatureServer",
      OS_OPENCARTO:
        ARCGIS_SERVICES_ROOT_URL + "Hosted/ospencarto/FeatureServer",
    },
  },
};
const GIS_PM_LAYER_NAME = "pollutant_metric";
const GIS_PM_ID_SLUG = "pm_";
const GIS_PM_ROADS_ID = `${GIS_PM_ID_SLUG}roadside`;
const GIS_PM_ROADS_COMP_ID = `${GIS_PM_ID_SLUG}roadside_comp`;
const GIS_PM_POINTS_SUPPLEMENTARY_ID = `${GIS_PM_ID_SLUG}supplementary_measurement_point`;
const GIS_PM_POINTS_FIXED_ID = `${GIS_PM_ID_SLUG}fixed_measurement_point`;
const GIS_PM_POLYGONS_ID = `${GIS_PM_ID_SLUG}polygons`;
const GIS_PM_POLYGONS_COMP_ID = `${GIS_PM_ID_SLUG}polygons_comp`;
const COMPLIANCE_YEARS = [
  {
    name: "2024",
    id: 2024,
  },
  {
    name: "2023",
    id: 2023,
  },
  {
    name: "2022",
    id: 2022,
  },
  {
    name: "2021",
    id: 2021,
  },
  {
    name: "2020",
    id: 2020,
  }
];
const DEFAULT_COMPLIANCE_YEAR = COMPLIANCE_YEARS[0]["id"];
const DOWNLOAD_FILE_TYPES = [
  { name: "Shapefile", value: "ShapeFile" },
  { name: "CSV", value: "CSV" },
  { name: "KML", value: "KML" },
  { name: "File GDB", value: "FileGeodatabase" },
  //   { name: "File GDB", value: "file geodatabase" },
];
const QUERY_DATA_BUTTON_ACTION = {
  title: "View Area",
  id: "get-data",
  className: "esri-icon-query-data",
};
const DEFAULT_POLLUTANT_METRIC_OPACITY = 0.5;
const ACTIVE_HIGHLIGHT_LINE_ID = "active_highlight";
export {
  APP_SETTINGS,
  ARCGIS_SERVICES_ROOT_URL,
  GIS_PM_LAYER_NAME,
  GIS_PM_ID_SLUG,
  GIS_PM_ROADS_ID,
  GIS_PM_POINTS_SUPPLEMENTARY_ID,
  GIS_PM_POINTS_FIXED_ID,
  GIS_PM_POLYGONS_ID,
  GIS_PM_POLYGONS_COMP_ID,
  GIS_PM_ROADS_COMP_ID,
  DEFAULT_COMPLIANCE_YEAR,
  COMPLIANCE_YEARS,
  MAP_OPTIONS,
  DOWNLOAD_FILE_TYPES,
  QUERY_DATA_BUTTON_ACTION,
  DEFAULT_POLLUTANT_METRIC_OPACITY,
  ACTIVE_HIGHLIGHT_LINE_ID,
};